import React from 'react';
import GlassCard from '../components/ui/Card';
import { getStatusPillClass, getPriorityPillClass } from '../utils/helpers';
// --- INÍCIO DA ALTERAÇÃO 1: Adicionando importações ---
import { ChevronRightIcon, RefreshIcon, SunIcon } from '../components/ui/Icons';
import useData from '../hooks/useData';
// --- FIM DA ALTERAÇÃO 1 ---

const ListView = ({ tasks, onTaskClick }) => {
    // --- INÍCIO DA ALTERAÇÃO 2: Importando a função de toggle do Meu Dia ---
    const { handleToggleMyDay } = useData();
    // --- FIM DA ALTERAÇÃO 2 ---
    return(
        <div className="p-4 space-y-4">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-bold text-white">Lista de Tarefas</h2>
            </div>
            <div className="overflow-y-auto h-[calc(100vh-200px)] space-y-3">
                {tasks.map(task => (
                    <GlassCard
                        key={task.id}
                        className="p-4 flex justify-between items-center hover:bg-white/20 transition-all duration-200"
                    >
                        <div className="flex items-center gap-4 flex-1 cursor-pointer" onClick={() => onTaskClick(task)}>
                            <div className="flex-1">
                                <h4 className="font-semibold text-white uppercase">{task.title}</h4>
                                <p className="text-sm text-gray-200 mt-1">{task.client}</p>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4">
                            {task.isAlteration && (
                                <div className="text-orange-400" title="Tarefa marcada para alteração">
                                    <RefreshIcon size={16} />
                                </div>
                            )}
                            <span className={`px-2 py-1 rounded-full text-xs ${getPriorityPillClass(task.priority)}`}>
                                {task.priority}
                            </span>
                            <span className={`px-2 py-1 rounded-full text-xs ${getStatusPillClass(task.status)}`}>
                                {task.status}
                            </span>
                            <span className="text-sm text-gray-300 hidden md:block">Prazo: {task.deadline || 'N/D'}</span>
                            {/* --- INÍCIO DA ALTERAÇÃO 3: Adicionando botão do Meu Dia e ícone de seta --- */}
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleToggleMyDay(task.id, task.isMyDay);
                                }}
                                title={task.isMyDay ? "Remover de Meu Dia" : "Adicionar ao Meu Dia"}
                                className="p-2 rounded-full hover:bg-white/20 transition-colors"
                            >
                                <SunIcon size={20} className={task.isMyDay ? 'text-yellow-400' : 'text-gray-400'} />
                            </button>
                            <ChevronRightIcon size={24} className="text-white" />
                            {/* --- FIM DA ALTERAÇÃO 3 --- */}
                        </div>
                    </GlassCard>
                ))}
            </div>
        </div>
    );
};

export default ListView;